import { useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFetchData } from "../../helpers/api";
import clsx from "clsx";
import Cookies from "js-cookie";

const theKey = Cookies.get("kalista-webtoken");
const cookieData = Cookies.get("kalista-web-user");
const customerData = cookieData ? JSON.parse(cookieData) : null;
const customerId = customerData?.Id ? customerData.Id : null;

const IconGroup = ({ iconWhiteClass }) => {
  const searchRef = useRef();
  const navigate = useNavigate();

  const { data: cartCount } = useFetchData(
    "cartItemCount",
    "/Customer/CartProductCount",
    { CustomerId: customerId },
    null,
    { enabled: !!customerId }
  );

  const handleClick = (e) => {
    e.currentTarget.nextSibling.classList.toggle("active");
  };

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
    document.body.style.overflow = "hidden";
  };

  const handleSearch = () => {
    const searchValue = searchRef.current.value.trim();
    if (searchValue) {
      navigate(`/search?query=${encodeURIComponent(searchValue)}`);
    }
  };

  const onkeyHandleSearch = (e) => {
    if (e.key === "Enter") {
      const searchValue = searchRef.current.value.trim();
      navigate(`/search?query=${encodeURIComponent(searchValue)}`);
    }
  };

  const showNav = customerData?.IsAllowedStoreLink === true;

  return (
    <div className={clsx("header-right-wrap", iconWhiteClass)}>
      <div className="same-style header-search d-none d-lg-block">
        <button className="search-active" onClick={(e) => handleClick(e)} style={{}}>
          <i className="pe-7s-search" />
        </button>
        <div className="search-content">
          <div className="search_form">
            <input
              type="text"
              placeholder="Search"
              name="search"
              ref={searchRef}
              onKeyDown={onkeyHandleSearch}
            />
            <button className="button-search" onClick={handleSearch}>
              <i className="pe-7s-search" />
            </button>
          </div>
        </div>
      </div>
      <div className="same-style account-setting d-lg-block">
        <button
          className="account-setting-active"
          onClick={(e) => handleClick(e)}
        >
          <i className="pe-7s-user-female" />
        </button>
        <div className={`account-dropdown ${theKey ? "is_logged_in" : ""}`}>
          <ul>
            {!theKey ? (
              <>
                <li>
                  <Link to="/login">SIGN IN</Link>
                </li>
                <li>
                  <Link to="/register">SIGN UP</Link>
                </li>
              </>
            ) : (
              <>
                <li>
                  <Link to="/orders">Orders</Link>
                </li>
                <li>
                  <Link to="/my-stock">My Stock</Link>
                </li>
                <li>
                  <Link to="/details">Company Details</Link>
                </li>
                {
                  showNav && (
                    <>
                      <li>
                        <Link to="/my-store">My Store</Link>
                      </li>
                      <li>
                        <Link to="/store-link">Store Link</Link>
                      </li>
                    </>
                  )
                }
                <li>
                  <Link to="/logout">Logout</Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
      <div className="same-style cart-wrap d-none d-lg-block">
        <Link className="icon-cart" to="/cart">
          <i className="pe-7s-shopbag" />
          <span className="count-style">{cartCount?.Data || 0}</span>
        </Link>
      </div>
      <div className="same-style cart-wrap d-block d-lg-none">
        <Link className="icon-cart" to="/cart">
          <i className="pe-7s-shopbag" />
          <span className="count-style">{cartCount?.Data || 0}</span>
        </Link>
      </div>
      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <button
          className="mobile-aside-button"
          onClick={() => triggerMobileMenu()}
        >
          <i className="pe-7s-menu" />
        </button>
      </div>
    </div>
  );
};

export default IconGroup;
